import { render, staticRenderFns } from "./SessionOverview.vue?vue&type=template&id=885fde8a&scoped=true"
import script from "./SessionOverview.vue?vue&type=script&lang=js"
export * from "./SessionOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885fde8a",
  null
  
)

export default component.exports